"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ServiceFetch_1 = __importDefault(require("../../utilities/ServiceFetch"));
/**
 * This class is used for fetching product data.
 */
var DexfWebplannerService = /** @class */ (function () {
    /**
     * Constructor.
     *
     * @param options Options.
     * @param options.endpoint Endpoint.
     * @param options.dexfApiKey DEXF API key.
     */
    function DexfWebplannerService(options) {
        this.maxItemsPerRequest = 50;
        this.endpoint = null;
        this.dexfApiKey = null;
        this.endpoint = options.endpoint;
        this.dexfApiKey = options.dexfApiKey;
    }
    /**
     * Fetches items from DEXF.
     *
     * @param items Array of items.
     * @param fields Fields.
     * @returns Promise.
     */
    DexfWebplannerService.prototype.getProducts = function (items, fields) {
        if (fields === void 0) { fields = null; }
        return __awaiter(this, void 0, void 0, function () {
            var sets, fieldsString, options, promises, parts, products, _i, parts_1, part, _a, _b, item;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        sets = this.getItemSets(items);
                        fieldsString = fields ? fields.join(',') : '*';
                        options = {
                            credentials: 'same-origin',
                            headers: {
                                'dexf-api-key': this.dexfApiKey
                            }
                        };
                        promises = sets.map(function (set) {
                            var itemId = _this.getItemsString(set);
                            var url = _this.endpoint + "?filter.itemId=" + itemId + "&fields=" + fieldsString;
                            return ServiceFetch_1.default.json(url, options);
                        });
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        parts = _c.sent();
                        products = [];
                        for (_i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
                            part = parts_1[_i];
                            for (_a = 0, _b = part['data']; _a < _b.length; _a++) {
                                item = _b[_a];
                                products.push(this.parseProduct(item));
                            }
                        }
                        return [2 /*return*/, products];
                }
            });
        });
    };
    /**
     * Fetches all items assigned to an application from DEXF.
     *
     * @param dexfApplicationId DEXF application ID.
     * @param fields Fields.
     * @returns Promise.
     */
    DexfWebplannerService.prototype.getApplicationProducts = function (dexfApplicationId, fields) {
        if (fields === void 0) { fields = null; }
        return __awaiter(this, void 0, void 0, function () {
            var fieldsString, url, response, products, _i, _a, item;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        fieldsString = fields ? fields.join(',') : '*';
                        url = this.endpoint + "?filter.appId=" + dexfApplicationId + "&fields=" + fieldsString;
                        return [4 /*yield*/, ServiceFetch_1.default.json(url, {
                                credentials: 'same-origin',
                                headers: {
                                    'dexf-api-key': this.dexfApiKey
                                }
                            })];
                    case 1:
                        response = _b.sent();
                        products = [];
                        for (_i = 0, _a = response['data']; _i < _a.length; _i++) {
                            item = _a[_i];
                            products.push(this.parseProduct(item));
                        }
                        return [2 /*return*/, products];
                }
            });
        });
    };
    /**
     * Parses product data.
     *
     * @param data Data.
     * @returns Item string.
     */
    DexfWebplannerService.prototype.parseProduct = function (data) {
        return {
            reason: data['reason'] || [],
            valid: data['valid'] || false,
            itemId: data['itemId'] || null,
            content: data['content'] ? this.parseProductContent(data['content']) : null
        };
    };
    /**
     * Parses product content data.
     *
     * @param data Data.
     * @returns Item string.
     */
    DexfWebplannerService.prototype.parseProductContent = function (data) {
        return {
            itemType: data['itemType'] || null,
            itemNoGlobal: data['itemNoGlobal'] || null,
            itemNoLocal: data['itemNoLocal'] || null,
            ruItemType: data['ruItemType'] || null,
            ruItemNo: data['ruItemNo'] || null,
            breathTakingItem: data['breathTakingItem'] || false,
            name: data['name'] || null,
            mainTypeCode: data['mainTypeCode'] || null,
            mainTypeName: data['mainTypeName'] || null,
            typeCode: data['typeCode'] || null,
            typeName: data['typeName'] || null,
            validDesignText: data['validDesignText'] || null,
            requiresAssembly: data['requiresAssembly'] || null,
            measure: data['measure'] || null,
            packageMeasure: data['packageMeasure'] || null,
            priceInformation: data['priceInformation'] || null,
            image: data['image'] || null,
            goodToKnow: data['goodToKnow'] || null,
            customerBenefit: data['customerBenefit'] || null,
            customerBenefitSummary: data['customerBenefitSummary'] || null,
            technicalInformation: data['technicalInformation'] || null,
            peopleAndPlanet: data['peopleAndPlanet'] || null,
            careInstruction: data['careInstruction'] || null,
            customerMaterial: data['customerMaterial'] || null,
            filterAttribute: data['filterAttribute'] || null,
            priceUnit: data['priceUnit'] || null,
            child: data['child'] || null,
            fullyLocalized: data['fullyLocalized'] || null,
            presentationGroupCode: data['presentationGroupCode'] || null,
            assemblyTime: data['assemblyTime'] || null,
            genericProduct: data['genericProduct'] || null,
            measureReference: data['measureReference'] || null,
            reason: data['reason'] || null,
            document: data['document'] || null,
            complementaryItem: data['complementaryItem'] || null,
            asset: data['asset'] || null,
            saleEndDateTime: data['saleEndDateTime'] || null,
            saleEndDateText: data['saleEndDateText'] || null
        };
    };
    /**
     * Returns an item string to be used in the request URL.
     *
     * @param items Array of items.
     * @returns Item string.
     */
    DexfWebplannerService.prototype.getItemsString = function (items) {
        return items.map(function (item) { return item.type.toUpperCase() + '-' + item.id; }).join(',');
    };
    /**
     * Returns item sets based on the maximum allowed items per request.
     *
     * @param items Array of items to parse.
     * @returns Product sets.
     */
    DexfWebplannerService.prototype.getItemSets = function (items) {
        var sets = [[]];
        var currentSet = sets[0];
        for (var i = 0, max = items.length; i < max; i++) {
            if (currentSet.length === this.maxItemsPerRequest) {
                currentSet = [];
                sets.push(currentSet);
            }
            if (items[i].id && items[i].type) {
                currentSet.push(items[i]);
            }
        }
        return sets;
    };
    return DexfWebplannerService;
}());
exports.default = DexfWebplannerService;
//# sourceMappingURL=DexfWebplannerService.js.map